import { Theme } from '@emotion/react';
import { FC } from 'react';

export enum SecondaryPaths {
  BASE = '/', // НЕ МЕНЯТЬ
  PLAYLISTS = '/playlists',
  PLAYCOURSES = '/playcourses',
  STATISTICS = '/stat',
  PLAYLIST_ADD_VIDEO = '/add-video',
  CREATE_LINK = '/create-link',
  EDIT_LINK = '/edit-link',
}

export enum Paths {
  BASE = '/',
  LOGIN = '/login',
  LOGIN_STUDENT = '/loginstudent',
  FORGOT_PASSWORD = '/password',
  FORGOT_COMPLETE = '/restore-password',
  REGISTRATION = '/registration',
  UPLOADED_VIDEOS = '/uploaded',
  UPLOADED_VIDEO = '/uploaded/video',
  UPLOADED_FILES = '/uploaded/files',
  UPLOADED_VIDEOS_PLAYLIST = '/uploaded/playlists',
  UPLOADED_PLAYCOURSES = '/uploaded/playcourses',
  FILES = '/files',
  VIEWED_VIDEOS = '/viewed',
  VIEWED_PLAYLISTS = '/viewed/playlists',
  ACCOUNT = '/account',
  VIDEO = '/video',
  VIDEO_CREATE = '/video/create',
  PLAYLIST = '/playlist',
  PLAYLISTS = '/playlists',
  PLAYCOURSE = '/playcourse',
  PLAYCOURSE_ADMIN = '/playcourse-admin',
  ANALYTICS = '/analytics',
  FINANCE = '/finance',
  PRIVACY_POLICY = '/privacy-policy',
  PUBLIC_OFFER = '/public-offer',
  MODULE1 = '/module1',
  MODULE1_VIEW = '/module1/view',
  AIMANAGER_MODULE1 = '/aimanager/module1',
  AIMANAGER_MODULE1_VIEW = '/aimanager/module1/view',
  USERS_ACCESS = '/users-access',
}

type TMenuPath = string | Paths;

export type TMenuItem = {
  path: TMenuPath;
  activePathTrigger: TMenuPath | TMenuPath[];
  Icon: FC;
  text: string;
  blockedModal?: {
    content: string;
    okText?: string;
    title: string;
  };
  strongEqual?: boolean;
  disabled?: boolean;
};

export type TIconBaseProps = {
  theme: Theme;
  isGreen?: boolean
};
